import RecapUnfold from "./recapUnfold";
import little_moto from '../img/little_moto.png'

export default class RecapUnfoldVehicule extends RecapUnfold {

    constructor(props) {
        super(props)
        this.bigTitle = 'Vérifier les informations de votre véhicule'
        this.title = 'Votre véhicule'
        this.modifyPage = 'vehicule'
    }

    doRender() {
        const isMoto = this.props.devis.type=='moto'
        return <>
            {isMoto?<>
                <label><b>Votre deux-roues <img src={little_moto}/></b><span>{this.value('marque')} {this.value('modele')} ({this.value('cylindree')})</span></label>
                </>:<>
                <label><b>Votre véhicule </b><span>{this.value('marque')} {this.value('modele')}</span></label>
            </>}

            {this.staticLabel("date_mise_en_circulation")}
            {this.staticLabel("date_acquisition")}
            {isMoto?<>
                {this.staticLabel("homologue",{forceDisplay:true})}
                </>:<>
            </>}
            {this.staticLabel("carte_grise_france",{forceDisplay:true})}
            {this.staticLabel("carte_grise_titulaire")}
            {this.staticLabel("usage")}
            {isMoto?<>
                {this.staticLabel("assur_23_mois",{forceDisplay:true})}
            </>:<>
            {this.staticLabel("assure_actuellement",{
                forceDisplay:true,
                forceLabel:'Assuré actuellement'})}
            
            </>}
            
        </>
    }
}